import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { documentsToSign } from '../utils/staffDocuments';
import '../pages/StaffDocuments.css';

// Staff home: once the club requires a document, asks staff who haven't signed
// it to read and sign it. Until then nobody is prompted; admins can still sign
// from the Staff documents tile before switching it on.
export default function StaffDocumentsCard() {
  const { user } = useAuth();
  const toSign = documentsToSign(user);
  if (user?.isPreview || toSign.length === 0) return null; // Preview as can't sign
  return (
    <div className="coc-card">
      <p>
        <strong>Read and sign the staff documents.</strong>
        {toSign.length === 1
          ? ` ${toSign[0].title} needs your signature before you can use staff pages.`
          : ` ${toSign.length} documents need your signature before you can use staff pages.`}
      </p>
      <Link to="/staff-documents" className="bk-btn bk-btn--primary bk-btn--sm">Read and sign</Link>
    </div>
  );
}
